import React, { useState } from "react";
import { Box, Button, Typography, Tabs, Tab, CircularProgress } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BarChartIcon from "@mui/icons-material/BarChart";
import KullaniciTanimla from "../components/kullaniciTanimla";
import AtamaIslemleri from "../components/atamaIslemleri";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import OgrenciKayitGetir from "../components/ogrenciKayitGetir";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

const AdminPanel = () => {
  const loading = useAuth();
  const [value, setValue] = useState(0);
  const [loadingButton] = useState(false);

  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const location = useLocation();
  const asl_kullanici_ad = location.state?.asl_kullanici_ad || "Bilinmeyen";
  const asl_kullanici_soyad = location.state?.asl_kullanici_soyad || "Kullanıcı";

  if (loading) {
    return <div>Loading...</div>; 
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          backgroundColor: "#e3f2fd", // Light blue color
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #bbdefb",
        }}
      >
        <Typography
          variant="body2"
          color="darkblue"
          sx={{ display: "flex", alignItems: "center", fontWeight: 'bold' }}
        >
          HOŞGELDİN, {asl_kullanici_ad} {asl_kullanici_soyad}
          <AccountCircleIcon sx={{ marginLeft: "8px" }} />
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogout}
          sx={{
            backgroundColor: "#1976d2",
            color: "white",
            borderRadius: '10px', // Rounded corners
            "&:hover": {
              backgroundColor: "#115293",
              transform: 'scale(1.001)', // Subtle hover effect
            },
          }}
        >
          {loadingButton ? <CircularProgress size={24} color="inherit" /> : "ÇIKIŞ YAP"}
        </Button>
      </Box>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="admin tabs"
        sx={{ paddingLeft: "10px", borderBottom: "1px solid #bbdefb" }} // Added border for tabs
      >
        <Tab label="KULLANICI EKLE" icon={<AccountCircleIcon />} />
        <Tab label="ATAMA İŞLEMLERİ" icon={<PlaylistAddIcon />} />
        <Tab label="ÖĞRENCİ SONUÇ İZLEME" icon={<BarChartIcon />} />
        <Tab label="GENEL SONUÇ İZLEME" icon={<BarChartIcon />} />
      </Tabs>
      <Box sx={{ padding: "10px" }}>
        {value === 0 && <KullaniciTanimla />}
        {value === 1 && <AtamaIslemleri />}
        {value === 2 && <OgrenciKayitGetir />}
        {value === 3 && <Typography>2</Typography>}
      </Box>
    </Box>
  );
};

export default AdminPanel;